import { Model, hasMany, belongsTo } from 'miragejs';

export default Model.extend({
  locations: hasMany('location', { inverse: null }),
  signInFieldActionRuleGroups: hasMany('sign-in-field-action-rule-group'),

  company: belongsTo(),
  summaryPage: belongsTo('summary-page'),
  agreementPage: belongsTo('agreement-page'),
  signInFieldPage: belongsTo('sign-in-field-page'),
  idScanPage: belongsTo('id-scan-page'),
  visualComplianceConfiguration: belongsTo('global-visual-compliance-configuration'),

  badge: belongsTo('badge'),
  photoPage: belongsTo('photoPage'),
  flows: hasMany('flow'),
  visitorDocumentContacts: hasMany('user'),
});
